import React, { Component } from 'react'
import classNames from 'classnames';
import { Spinner, TRWrapper } from '../common/Helper';
import { formatSecs } from '../../lib/utils'
import BurnDown from '../perf/BurnDown';
import IssueGroup from '../perf/IssueGroup';
import IssueBoard from '../pages/IssueBoard';

const TagCloud = ({ tags, tagStatus, parent }) => {
    let list = [];
    for (var name in tags) {
        const active = Boolean(tagStatus[name]);
        list.push(
            <button
                key={name}
                type="button"
                onClick={parent.onTagClick.bind(parent, name)}
                className={classNames('tag-chip', { 'is-active': active })}
            >
                {name}
                <span className="tag-chip__n">{tags[name].tasks}</span>
                <span className="tag-chip__n is-time">{formatSecs(tags[name].spent)}</span>
            </button>
        );
    }
    list = list.sort((a, b) => a.key.localeCompare(b.key));
    return <div className="tag-cloud">{list}</div>;
}

const TimePersonTable = ({ total, people, error, message }) => {
    const list = [];
    for (var name in people) {
        list.push(
            <tr key={name}>
                <td>{name}</td>
                <td className="ds-nums">{formatSecs(people[name].totalSpent)} / {formatSecs(people[name].totalEstimate)}</td>
            </tr>
        );
    }

    if (error) {
        list.push(<TRWrapper key="error" colSpan="2"><div className="issue-empty" style={{ color: 'var(--ds-danger)' }}>{error}</div></TRWrapper>);
    } else if (message) {
        list.push(<TRWrapper key="message" colSpan="2"><div className="issue-empty">{message}</div></TRWrapper>);
    } else if (list.length === 0) {
        list.push(<TRWrapper key="loading" colSpan="2"><Spinner /></TRWrapper>);
    }

    return (
        <div className="ds-panel">
            <div className="ds-panel__head">
                <h3 className="ds-panel__title">Time by person</h3>
                <span className="ds-panel__sub ds-nums">{formatSecs(total)}</span>
            </div>
            <div className="ds-table-wrap">
                <table className="ds-table">
                    <thead>
                        <tr>
                            <th>Person</th>
                            <th>Spent / Estimate</th>
                        </tr>
                    </thead>
                    <tbody>{list}</tbody>
                </table>
            </div>
        </div>
    );
}

class Client extends Component {

    constructor(arg) {
        super(arg);
        this.state = {
            issueList: null,
            filter: '',
            tagStatus: {},
            error: null
        }
    }
    filteredIssues() {
        let newList = this.state.issueList;
        if (!newList) {
            return {
                tags: {},
                issues: null,
                total: 0,
                people: {},
            };
        }
        let { tagStatus, filter } = this.state;
        filter = filter.toLowerCase();
        const tags = newList.reduce((acc, item) => {
            item.labels.forEach(label => {
                if (!acc[label]) {
                    acc[label] = {
                        tasks: 0,
                        spent: 0
                    }
                }
                acc[label].tasks++;
                acc[label].spent += item.timeSpent;
            });
            return acc;
        }, {});

        if (Object.keys(tagStatus).length != 0) {
            newList = newList.filter(item => item.labels.some(s => tagStatus[s]))
        }
        if (filter != '') {

            if (filter.indexOf("!") == 0) {
                filter = filter.replace("!", "");
                newList = newList.filter(item => {
                    return item.title.toLowerCase().indexOf(filter) < 0 &&
                        item.assignee.name.toLowerCase().indexOf(filter) < 0 &&
                        item.labels.join().toLowerCase().indexOf(filter) < 0
                });
            } else {

                newList = newList.filter(item => {
                    return item.title.toLowerCase().indexOf(filter) >= 0 ||
                        item.assignee.name.toLowerCase().indexOf(filter) >= 0 ||
                        item.labels.join().toLowerCase().indexOf(filter) >= 0;
                });
            }
        }

        newList = newList.sort((a, b) => {
            const abase = a.state == 'closed' ? 1000 * 86400 : 0;
            const bbase = b.state == 'closed' ? 1000 * 86400 : 0;
            return (abase) - (bbase);
        });

        const total = newList.reduce((acc, item) => acc + parseInt(item.timeSpent), 0);

        const map = newList.reduce((acc, item) => {
            if (!item.assignee) {
                return acc;
            }
            if (!acc[item.assignee.name]) {
                acc[item.assignee.name] = new IssueGroup(item.assignee.username,
                    item.assignee.name)
            }
            acc[item.assignee.name].addIssue(item);
            return acc
        }, {});

        return {
            tags: tags,
            issues: newList,
            total: total,
            people: map
        };
    }

    fetchData() {
        this.setState({
            issueList: null,
            error: null,
            people: null,
            total: 0
        });
    }

    componentDidMount() {
        this.fetchData();
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps != this.props) {
            this.fetchData();
        }
    }

    onFilter(e) {
        this.setState({ filter: e.target.value });
    }

    onTagClick(name) {
        if (!this.state.tagStatus[name]) {
            this.state.tagStatus[name] = 1;
        } else {
            delete this.state.tagStatus[name];
        }
        this.forceUpdate();
    }
    render() {
        const { error, tagStatus } = this.state;
        const clientId = this.props.match.params.clientId;
        const { total, people, issues, tags } = this.filteredIssues();

        let message = null;
        let burnDown = null, board = null;
        const empty = <div className="issue-empty">Empty list</div>;

        if (issues) {
            if (issues.length === 0) {
                message = "Empty list";
                burnDown = empty;
                board = empty;
            } else {
                burnDown = <BurnDown issueList={issues} />;
                board = <IssueBoard issues={issues} mode='project' id={clientId} />;
            }
        }

        return <div>
            <div className="page-head">
                <h2>{clientId}</h2>
                <span className="ds-badge is-accent">Client</span>
            </div>

            <div className="proj-grid">
                <div>{burnDown}</div>
                <div className="proj-side">
                    <TimePersonTable error={error} message={message} people={people} total={total} />
                    <TagCloud tags={tags} tagStatus={tagStatus} parent={this} />
                </div>
            </div>

            <div className="ds-field-row" style={{ justifyContent: 'flex-end' }}>
                <input
                    onChange={this.onFilter.bind(this)}
                    className="ds-input"
                    placeholder="Filter issues…"
                    style={{ maxWidth: '320px' }}
                />
            </div>
            {board}
        </div>;
    }
}
export default (Client);